'use strict';

var _ = require('lodash');

module.exports = {

  _unregistry: {},

  cleanup: function ($scope) {
    _.forEach(this._unregistry[$scope.$id], function (unregisterFn) {
      unregisterFn();
    });
    delete this._unregistry[$scope.$id];
  },

  getWatchFn: function (key, context) {
    
    if (!context) {
      throw new Error('Missing context');
    }

    
    var getValue = function (key, obj) {
      var target = obj;
      var keyArr = key.split('.');

      if (keyArr.length === 1) {
        return obj[key];
      } else {
        while (keyArr.length) {
          key = keyArr.shift();
          target = target[key];
        }
        return target;
      }
    };

    return function () {
      return getValue(key, context);
    };
  },

  watch: function ($attrs, $scope, context, prop, handler, type) {
    
    var splitProp = prop.split('.')[0];
    this._unregistry[$scope.$id] = this._unregistry[$scope.$id] || {};

    if ($attrs[splitProp]) {
      var watcher = $scope.$watch.bind($scope);

      if (type === 'collection') {
        watcher = $scope.$watchCollection.bind($scope);
      }

      // remove any existing watcher on the same property... 
      // NOTE: Assumes that we only want one watcher attached to a property at 
      // any given time.
      var unregisterFn = this._unregistry[$scope.$id][prop];
      if (unregisterFn) {
        unregisterFn()
        delete this._unregistry[$scope.$id][prop];
      }

      // setup the watcher and save the unregister function
      unregisterFn = watcher(this.getWatchFn(prop, context), function (newVal, oldVal) {
        handler(newVal, oldVal);
      });

      this._unregistry[$scope.$id][prop] = unregisterFn;
    }
  }
};



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/utils/CtrlUtil.js